import axiosInstance from "@/axiosInstance";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBlogs = createAsyncThunk(
    "blog/fetchBlogs",
    async ({ tags = [], search = "", page = 1, limit = 10 } = {}, { rejectWithValue }) => {
        try {
            let url = "/api/website/blogs";
            const queryParams = [];

            if (tags.length > 0) {
                queryParams.push(...tags.map(tagId => `tags[]=${tagId}`));
            }

            if (search) {
                queryParams.push(`search=${search}`);
            }

            queryParams.push(`page=${page}`, `limit=${limit}`);

            if (queryParams.length > 0) {
                url += `?${queryParams.join("&")}`;
            }
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Something went wrong");
        }
    }
);


export const fetchBlogBySlug = createAsyncThunk(
    "blog/fetchBlogBySlug",
    async (slug, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/website/blogs/detail/${slug}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Something went wrong");
        }
    }
);

export const fetchTags = createAsyncThunk(
    "blog/fetchTags",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/api/website/blogs/tags");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Something went wrong");
        }
    }
);

export const blogSlice = createSlice({
    name: "blog",
    initialState: {
        blogs: [],
        blog: null,
        tags: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogs.fulfilled, (state, action) => {
                state.loading = false;
                state.blogs = action.payload;
            })
            .addCase(fetchBlogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchBlogBySlug.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogBySlug.fulfilled, (state, action) => {
                state.loading = false;
                state.blog = action.payload;
            })
            .addCase(fetchBlogBySlug.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchTags.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.loading = false;
                state.tags = action.payload;
            })
            .addCase(fetchTags.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }}
);

export default blogSlice.reducer;